/*
 * This component is responsible for state transitions.
 *
 * @author Cargomatic Engineering
 * @usage <StateTransition />
 *
 */
import PropTypes from 'prop-types';
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { humanize, titleize } from 'underscore.string';
import { sluggify } from 'utils/localization/utils';
import { Translation } from 'react-i18next';
import { Button, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, } from '@cargomatic/ui';
const getStatefulButton = (state, direction) => {
    return state.isValid
        ? getButton(state, direction)
        : getOverlayButton(state, direction);
};
const getOverlayButton = (state, direction) => {
    return (React.createElement(TooltipProvider, null,
        React.createElement(Tooltip, null,
            React.createElement(TooltipTrigger, { asChild: true },
                React.createElement("span", { className: !state.isValid ? 'cursor-not-allowed' : '' }, getButton(state, direction))),
            React.createElement(TooltipContent, null, state.reason || titleize(humanize(state.label))))));
};
const getButton = (state, direction) => {
    const variant = direction === 'left' ? 'destructive' : 'default';
    return (React.createElement(Button, { "data-testid": "button-4cf2fd56", variant: variant === 'destructive' ? 'outline' : 'default', className: direction === 'right'
            ? 'bg-green-600 hover:bg-green-700 text-white'
            : 'border-red-500 text-red-500 hover:bg-red-50', disabled: !state.isValid, onClick: () => state.onClick(state.label) },
        direction === 'left' && React.createElement(ChevronLeft, { className: "w-4 h-4" }),
        React.createElement(Translation, null, (t) => t(sluggify(state.label || ''))),
        direction === 'right' && React.createElement(ChevronRight, { className: "w-4 h-4" })));
};
const StateTransition = (props) => {
    const { regress, progress, onClick, dataTestId } = props;
    /* This is dirty... */
    if (regress)
        regress.onClick = onClick;
    if (progress)
        progress.onClick = onClick;
    return (React.createElement("div", { "data-testid": dataTestId, className: "flex items-center justify-start gap-2" },
        regress && getStatefulButton(regress, 'left'),
        progress && getStatefulButton(progress, 'right')));
};
StateTransition.propTypes = {
    regress: PropTypes.object, // The transition backward
    progress: PropTypes.object, // The transition forward
};
StateTransition.defaultProps = {
    regress: {
        label: 'Back',
        isValid: true,
        reason: '',
    },
    progress: {
        label: 'Forward',
        isValid: false,
        reason: 'Cause stone cold said so!',
    },
    onClick: () => {
        console.log('Implement Me!');
    },
};
export default StateTransition;
